import { getApiExportBaseUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
export async function verifyPiperunToken(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/piperun/token?skip_handle_error`, payload);
}
export async function listPiperunPipelines(page) {
    return await Vue.axios.get(`${getApiExportBaseUrl()}/user/piperun/list_pipelines?page=${page}`);
}
export async function verifyMeetimeToken(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/meetime/token?skip_handle_error`, payload);
}
export async function listMeetimeCadences() {
    return await Vue.axios.get(`${getApiExportBaseUrl()}/user/meetime/list_cadences?skip_handle_error`);
}
export async function listMeetimeOwners() {
    return await Vue.axios.get(`${getApiExportBaseUrl()}/user/meetime/list_owners?skip_handle_error`);
}
export async function verifyFunilDeVendasCredentials(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/funildevendas/token?skip_handle_error`, payload);
}
export async function verifyTotvsTokens(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/totvs/token?skip_handle_error`, {
        accessToken: payload.accessToken,
        integrationToken: payload.integrationToken,
    });
}
export async function verifyAgendorToken(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/agendor/token?skip_handle_error`, payload);
}
export async function verifyBitrix24Url(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/bitrix24/url?skip_handle_error`, payload);
}
export async function listBitrix24Pipelines() {
    return await Vue.axios.get(`${getApiExportBaseUrl()}/user/bitrix24/list_pipelines`);
}
export async function listBitrix24Stages(pipelineId) {
    return await Vue.axios.get(`${getApiExportBaseUrl()}/user/bitrix24/list_stages?pipelineId=${pipelineId}`);
}
export async function verifyPloomesToken(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/ploomes/token?skip_handle_error`, payload);
}
export async function verifyPipedriveToken(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/pipedrive/token?skip_handle_error`, payload);
}
export async function verifyRdStationToken(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/rdstation/token?skip_handle_error`, payload);
}
export async function getHubspotAuthenticationUri(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/hubspot/generate_authentication_uri`, payload);
}
export async function getHubspotToken(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/hubspot/token`, payload);
}
export async function getSalesforceToken(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/salesforce/token`, payload);
}
export async function getSalesforceAuthenticationUri(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/salesforce/generate_authentication_uri`, payload);
}
export async function getZohoToken(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/zoho/token`, payload);
}
export async function getZohoAuthenticationUri(payload) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/user/zoho/generate_authentication_uri`, payload);
}
